// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"061e9b0a","126":"e7fdbc9c","131":"9a58c99c","136":"99cc0e41","215":"d6b688ea","269":"af2103b8","374":"cc97590f","378":"bfb820c2","382":"c865aa21","395":"33b0ed6b","781":"e51a89ee","790":"e925c2a1","928":"792aa2a0"}[chunkId] + ".chunk.js";
};